import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { SxProps, Theme, useMediaQuery } from '@mui/material'
interface Props {
  title: string
  children: React.ReactNode
  sx?: SxProps<Theme> 
}
const SectionForm = ({ title, children, sx }: Props) => {
  const isMobile = useMediaQuery('(max-width:800px)')
  const isSmallMobile = useMediaQuery('(max-width:480px)')
  
  return (
    <Box component='section' sx={{ ...sx }}>
      <Typography 
        variant='h5' 
        sx={{ 
          textTransform: 'uppercase', 
          mb: isSmallMobile ? '12px' : isMobile ? '16px' : '20px', 
          fontWeight: '700',
          fontSize: isSmallMobile ? '14px' : isMobile ? '16px' : '18px'
        }}
      >
        {title}
      </Typography>
      <Box sx={{ 
        border: '1px solid #DADCDD', 
        pt: isSmallMobile ? '20px' : isMobile ? '28px' : '38px', 
        px: isSmallMobile ? '16px' : isMobile ? '24px' : '32px', 
        pb: isSmallMobile ? '24px' : isMobile ? '32px' : '47px'
      }}>
        {children}
      </Box>
    </Box>
  )
}

export default SectionForm
